import React from "react";
import { motion } from "framer-motion";
import {
  ExclamationTriangleIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";

const WarningBanner: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6"
    >
      <div className="flex flex-col lg:flex-row lg:items-start space-x-3">
        <ExclamationTriangleIcon className="h-6 w-6 text-red-600 flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="font-semibold text-red-800 mb-2">Important Notice</h3>
          <p className="text-red-700 text-sm leading-relaxed">
            If you are booking a lesson for today or within 24 hours of the
            lesson start time, you must call us to make the booking.
          </p>
          <div className="flex flex-col lg:flex-row items-start gap-2 lg:gap-0 lg:items-center mt-3 text-red-800">
            <div className="flex items-center">
              <PhoneIcon className="h-4 w-4 mr-2" />
              <span className="font-semibold">080-5357-6420</span>
            </div>

            <span className="ml-2 text-sm text-red-600">
              (7am - 8pm Japan Time)
            </span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default WarningBanner;
